/**
 * Copyright (c) 2025-2026 eBUCIS, LLC. All rights reserved.
 *
 * Game Service - API calls for practice games
 */

import api from './api'

const gameService = {
  async getQuestions(domain, count = 10, difficulty = null) {
    const params = { domain, count }
    if (difficulty) params.difficulty = difficulty
    const res = await api.get('/games/questions', { params })
    return res.data.questions
  },

  async checkAnswer(questionId, selectedOptionId) {
    const res = await api.post('/games/check-answer', { questionId, selectedOptionId })
    return res.data
  }
}

export default gameService
